import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll to the top on every route change. SPAs keep the previous
// scroll position by default, so navigating from a scrolled-down page would
// land you mid-page on the next one.
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        // Fallback for browsers/containers that scroll the document element.
        if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    }, [pathname]);

    return null;
};

export default ScrollToTop;
